import { AfterViewInit, Component, Injector, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ToastrService } from "ngx-toastr";
import { HelperService } from "../../../../services/helperService";
import { FormInlineiframeComponent } from "../form-inlineiframe/form-inlineiframe.component";

@Component({
	selector: "tig-form-usermanagement",
	templateUrl: "../form-inlineiframe/form-inlineiframe.component.html",
	styleUrls: ["../form-inlineiframe/form-inlineiframe.component.scss"],
})
export class FormGallerybuilderComponent
	extends FormInlineiframeComponent
	implements OnInit, AfterViewInit
{
	public static IFRAME_ID = "iframe-gallerybuilder";

	constructor(
		private OBJ_route: ActivatedRoute,
		OBJ_injector: Injector,
		OBJ_helper_service: HelperService,
		OBJ_toastr_service: ToastrService,
		OBJ_loading_spinner: Ng4LoadingSpinnerService
	) {
		super(
			OBJ_injector,
			OBJ_helper_service,
			OBJ_toastr_service,
			OBJ_loading_spinner
		);
	} // end constructor

	ngAfterViewInit(): void {
		const iFrame = document.getElementById(this.getIFrameID());
		iFrame.setAttribute("scrolling", "no");
	}

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID() {
		return FormGallerybuilderComponent.IFRAME_ID;
	} // end function getIFrameID

	ngOnInit() {
		const galleryId = this.OBJ_route.snapshot.paramMap.get("id");
		this.OBJ_field_config._links.iframe.href = `/tools/gallerybuilder/gallery/${galleryId}`;
	}
}
